import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function HeaderSticky() {
  useEffect(() => {
    // Wait for Calendly to be available
    const checkCalendly = setInterval(() => {
      if (window.Calendly) {
        clearInterval(checkCalendly);
      }
    }, 100);

    return () => clearInterval(checkCalendly);
  }, []);

  const handleCalendlyClick = (e) => {
    e.preventDefault();
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/keshav_sharma/dreamspace-demo'
      });
    }
  };

  return (
    <>
      <div
        id="desktop-header"
        className="container-fluid bg-primary headersticky"
        style={{ display: "grid" }}
      >
        <div className="container">
          <nav
            className="navbar navbar-expand-lg bg-primary navbar-light p-lg-0"
            style={{ margin: "0px 80px" }}
          >
            <div className="col-md-3">
              <Link to="/" className="navbar-brand">
                <img src="img/augrade_logo.png" alt="augrade logo" />
              </Link>
            </div>
            <div className="col-md-9">
              <button
                type="button"
                className="navbar-toggler me-0"
                data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarCollapse">
                <div className="navbar-nav">
                  <a href="https://calendly.com/keshav_sharma/dreamspace-demo" onClick={handleCalendlyClick} className="nav-item nav-link active">
                    Demo
                  </a>
                  <Link to="/OurStory" className="nav-item nav-link active">
                    About us
                  </Link>
                  <Link to="/Career" className="nav-item nav-link active">
                    Career
                  </Link>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>

      {/* Mobile Header */}
      <div className="mobile-header container-fluid bg-primary sticky-top">
        <div className="container">
          <nav className="navbar navbar-expand-lg bg-primary navbar-light p-lg-0">
            <a href="/" className="navbar-brand">
              <img src="img/augrade_logo.png" alt="" />
            </a>
            <button
              type="button"
              className="navbar-toggler me-0"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <div className="navbar-nav" style={{ marginBottom: "15px" }}>
                <Link to="/Dreamspace" className="nav-item nav-link active">
                  Dreamspace
                </Link>
                <Link to="/OurStory" className="nav-item nav-link active">
                  About us
                </Link>
                <Link to="/Career" className="nav-item nav-link active">
                  Career
                </Link>
                <a
                  href="https://forms.gle/cSp2GHjgHdQMVRLD8"
                  target="_blank"
                  className="nav-item nav-link active"
                >
                  Free trial
                </a>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
}

export default HeaderSticky;
